import { render, staticRenderFns } from "./PersonalMedicoFirma.vue?vue&type=template&id=d18818a4&scoped=true"
import script from "./PersonalMedicoFirma.vue?vue&type=script&lang=js"
export * from "./PersonalMedicoFirma.vue?vue&type=script&lang=js"
import style0 from "./PersonalMedicoFirma.vue?vue&type=style&index=0&id=d18818a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18818a4",
  null
  
)

export default component.exports